'use client'

import { Grid, Typography } from '@mui/material'
import { useContext, useEffect } from 'react'
import { gql, useQuery } from '@apollo/client'
import { AuthContext, GetSubscription, Section, Module, Logger } from '@wolfdanepug/common-react'
import PlansSummary from '../../components/plan/PlansSummary'
import SubscriptionOverview from '../../components/subscription/SubscriptionOverview'
import dashboard, { enabled } from '../../dashboard'
import { PageContext } from '../../context/page'

// import AppConfig from '@/context/app/AppConfig'

const SubscriptionModule = () => {
	const { data, loading, error } = useQuery(gql(GetSubscription))
	const { setPage } = useContext(PageContext)
	const subscription = data?.getSubscription

	useEffect(() => {
		setPage({
			title: 'Member Dashboard',
			description: 'Manage your Wolf Dane Pug Account'
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		error && Logger.error(error)
	}, [error])

	if (loading) {
		return null
	}

	return (
		<Module {...dashboard.subscription}>
			<SubscriptionOverview subscription={subscription} showModifyMessage={false}>
				<PlansSummary subscription={subscription} />
			</SubscriptionOverview>
		</Module>
	)
}

export default function Page() {
	const { useContextUser } = useContext(AuthContext)
	const user: any = useContextUser()

	return (
		<>
			<Section>
				<Grid container spacing={3}>
					<Grid item xs={12} md={8}>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<Module {...dashboard.welcome} title={`Hi, ${user?.firstName}`} />
							</Grid>
							{enabled.includes('gourmetPoints') && (
								<Grid item xs={12} md={5}>
									<Module {...dashboard.gourmetPoints} title="50" />
								</Grid>
							)}
							{enabled.includes('refer') && (
								<Grid item xs={12} md={7}>
									<Module {...dashboard.refer} />
								</Grid>
							)}
							{enabled.includes('events') && (
								<Grid item xs={12} md={7}>
									<Module {...dashboard.events}>
										<Typography variant="caption">
											There are no upcoming events, please check back often. We look forward to
											meeting your and your furry friend.
										</Typography>
									</Module>
								</Grid>
							)}
							{enabled.includes('profile') && (
								<Grid item xs={12} md={5}>
									<Module {...dashboard.profile} />
								</Grid>
							)}
						</Grid>
					</Grid>
					<Grid item xs={12} md={4}>
						<SubscriptionModule />
					</Grid>
				</Grid>
			</Section>
		</>
	)
}
